import React, { useEffect, useState, useContext } from "react";
import styled, { ThemeProvider } from "styled-components";
import {
  IconPeopleMan1,
  MobileDrawer,
  SiteIconImage,
  themeFromSiteConfig,
  useSiteContext
} from "@americanbible/uikit";

import { AppContext } from "../App/AppProvider";
import { useAuthContext } from "../Auth/AuthContext";
import { ViewSettingsMenu } from "../UI/ViewSettingsMenu";

const StyledSiteDrawer = styled(MobileDrawer)`
  z-index: 9999;
  transition: transform 150ms ease-in-out;
  transform: translateX(
    ${props => (props.anchor === "left" ? "-100%" : "100%")}
  );
  ${({ theme }) => theme.darkMode && `background: ${theme.computedPrimary};`}
  box-shadow: unset;

  &.open {
    transform: translateX(0);
    box-shadow: 2px 0px 6px rgba(0, 0, 0, 0.25);
  }
`;

const SiteDrawerOverlay = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 9998;
`;

const SiteDrawer = ({ theme }) => {
  const [settingsVisible, setSettingsVisiblity] = useState(false);
  const site = useSiteContext();
  const { drawerIsOpen, toggleDrawer } = useContext(AppContext);
  const { isAuthenticated } = useAuthContext();
  const anchor = site.scriptDirection === "rtl" ? "right" : "left";

  useEffect(() => {
    !drawerIsOpen && setSettingsVisiblity(false);
  }, [drawerIsOpen]);

  return (
    <ThemeProvider theme={{ ...themeFromSiteConfig(site), ...theme }}>
      <>
        {drawerIsOpen && <SiteDrawerOverlay onClick={toggleDrawer} />}
        <StyledSiteDrawer
          anchor={anchor}
          toggle={toggleDrawer}
          className={drawerIsOpen && "open"}
          icon={<SiteIconImage width={54} />}
        >
          {({ iconColor, InternalLink, Action }) => (
            <>
              <Action onClick={() => setSettingsVisiblity(!settingsVisible)}>
                <ViewSettingsMenu
                  anchor={anchor}
                  iconColor={iconColor}
                  open={drawerIsOpen && settingsVisible}
                />
              </Action>
              {site.enabledUserAccounts && (
                <InternalLink
                  onClick={toggleDrawer}
                  to={isAuthenticated ? "/user-settings" : "/auth"}
                >
                  <IconPeopleMan1 color={iconColor} />
                </InternalLink>
              )}
            </>
          )}
        </StyledSiteDrawer>
      </>
    </ThemeProvider>
  );
};

export default SiteDrawer;
